module.exports = __webpack_public_path__ + "static/media/icon.64a3e3b9.jpg";